/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DefaultItem from "views/Items/DefaultItem";
import {format, parseISO} from "date-fns";
import MDProgress from "../../../../../../components/MDProgress";
import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";

const getColor = (value) => {
    if (value < 25) {
        return "error";
    } else if (value >= 25 && value < 75) {
        return "warning";
    } else if (value >= 75 && value < 100) {
        return "warning";
    } else {
        return "success";
    }
};

function InfoCard({participants, start_date, end_date, event_code, number_of_processed, number_of_photos}) {
    return (
        // <Card sx={{ height: "100%" }}>
        <Card>
            <MDBox pt={2} px={2} lineHeight={1}>
                <MDTypography variant="h6" fontWeight="medium">
                    Information
                </MDTypography>
            </MDBox>
            <MDBox p={2}>
                <DefaultItem
                    color="info"
                    icon="person_add"
                    title="Participants"
                    description={participants}
                />
                <MDBox mt={2.5}>
                    <DefaultItem
                        color="info"
                        icon="event_available"
                        title="Start Date"
                        description={parseISO(start_date).toLocaleString()}
                    />
                </MDBox>
                <MDBox mt={2.5}>
                    <DefaultItem
                        color="info"
                        icon="event_busy"
                        title="End Date"
                        description={parseISO(end_date).toLocaleString()}
                    />
                </MDBox>
                <MDBox mt={2.5}>
                    <DefaultItem
                        color="info"
                        icon="key"
                        title="Event Key"
                        description={event_code}
                    />
                </MDBox>
                <MDBox mt={2.5}>

                <MDTypography variant="caption" color="text">
                    Processed Photo Size ({number_of_processed} / {number_of_photos}):
                </MDTypography>
                    <MDProgress text={number_of_processed + "/" + number_of_photos} variant="gradient" value={(number_of_processed/number_of_photos)*100}
                            color={getColor((number_of_processed/number_of_photos)*100)} />
                </MDBox>
            </MDBox>
        </Card>
    );
}

export default InfoCard;
